var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgQuote(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 33,
    viewBox: "0 0 21 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.4998 10.7351C20.4998 17.1141 17.2743 28.1141 8.55423 32.4091C7.73531 32.8123 7.22298 31.7794 7.90482 31.1648C13.8591 25.798 15.8683 20.2385 10.5 20.9703C4.97723 20.9703 0.5 16.3875 0.5 10.7351C0.5 5.08281 4.97723 0.5 10.5 0.5C16.0228 0.5 20.5 5.08281 20.5 10.7351H20.4998Z",
    fill: "#6D95FC",
    stroke: "#151515"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuote);
export default __webpack_public_path__ + "static/media/quote.4b892df6bd0aa8fda34cf588bef17eed.svg";
export { ForwardRef as ReactComponent };